import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import WaveformTrimmer from "./WaveformTrimmer";
import MetadataEditor from "./MetadataEditor";
import "../styles.css";

const SettingsModal = ({
  isOpen,
  onClose,
  file,
  fileSettings,
  fileIndex,
  onUpdateFileSettings,
  isConverting,
  ffmpeg,
}) => {
  const [localSettings, setLocalSettings] = useState(fileSettings);

  useEffect(() => {
    if (isOpen) {
      setLocalSettings(fileSettings);
    }
  }, [isOpen, fileSettings]);

  if (!isOpen || !file || !localSettings) return null;

  const handleMetadataChange = (newMetadata) => {
    setLocalSettings((prev) => ({ ...prev, metadata: newMetadata }));
  };

  const handleSettingsChange = (newSettings) => {
    setLocalSettings((prev) => ({ ...prev, ...newSettings }));
  };
  
  const handleFormatChange = (e) => {
    setLocalSettings((prev) => ({ ...prev, format: e.target.value }));
  };
  
  const handleBitrateChange = (e) => {
    setLocalSettings((prev) => ({ ...prev, bitrate: e.target.value }));
  };

  const handleNormalizeToggle = (isNormalized) => {
    setLocalSettings((prev) => ({ ...prev, normalize: isNormalized }));
  };

  const handleSave = () => {
    onUpdateFileSettings(fileIndex, localSettings);
    onClose();
  };

  const handleCancel = () => {
    onClose();
  };

  const closeButtonStyle = {
    position: "absolute",
    top: "15px",
    right: "15px",
    fontSize: "1.5rem",
    fontWeight: "bold",
    cursor: "pointer",
    border: "none",
    background: "none",
  };
  
  const modalContent = (
    <div className="modal-overlay" onClick={handleCancel}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button style={closeButtonStyle} onClick={handleCancel}>
          &times;
        </button>
        <h2>詳細設定 - {file.name}</h2>

        {/* 波形表示エリア - 横幅いっぱいに表示 */}
        <div style={{ marginTop: "20px" }}>
          <WaveformTrimmer
            file={file}
            fileSettings={localSettings}
            onUpdateFileSettings={handleSettingsChange}
            disabled={isConverting}
            ffmpeg={ffmpeg}
          />
        </div>

        {/* 2カラムの設定エリア */}
        <div style={{ display: "flex", gap: "20px", marginTop: "20px", alignItems: "flex-start", flexWrap: "wrap" }}>
          
          {/* 左側の設定項目 - Flexコンテナ化 */}
          <div style={{ flex: 1, minWidth: "300px", display: "flex", flexDirection: "column", gap: "15px" }}>
            <div className="settings-column">
              <h3>変換設定</h3>
              <div style={{ marginBottom: "15px" }}>
                <label style={{ display: "block", marginBottom: "5px" }}>
                  出力形式:
                </label>
                <select
                  onChange={handleFormatChange}
                  value={localSettings.format}
                  style={{ width: "100%", padding: "8px" }}
                  disabled={isConverting}
                >
                  <option value="mp3">MP3</option>
                  <option value="wav">WAV</option>
                  <option value="ogg">OGG</option>
                  <option value="flac">FLAC</option>
                  <option value="aac">AAC</option>
                  <option value="aiff">AIFF</option>
                </select>
              </div>
              
              <div>
                <label style={{ display: "block", marginBottom: "5px" }}>
                  ビットレート:
                </label>
                <select
                  onChange={handleBitrateChange}
                  value={localSettings.bitrate}
                  style={{ width: "100%", padding: "8px" }}
                  disabled={isConverting || localSettings.format === 'wav' || localSettings.format === 'flac' || localSettings.format === 'aiff'}
                >
                  <option value="128k">128kbps (標準)</option>
                  <option value="192k">192kbps (高音質)</option>
                  <option value="320k">320kbps (最高音質)</option>
                </select>
              </div>

              <div style={{ marginTop: "10px" }}>
                <label>
                  <input
                    type="checkbox"
                    checked={localSettings.normalize}
                    onChange={() => handleNormalizeToggle(!localSettings.normalize)}
                    disabled={isConverting}
                  />
                  音量を自動で均一化する（ノーマライズ）
                </label>
              </div>
            </div>
          </div>
          
          {/* 右側のメタデータ編集エリア */}
          <div style={{ flex: 1, minWidth: "300px" }}>
            <MetadataEditor
              fileMetadata={localSettings.metadata}
              onMetadataChange={handleMetadataChange}
              disabled={isConverting}
            />
          </div>
        </div>

        <div style={{ marginTop: "20px", textAlign: "right" }}>
          <button
            onClick={handleCancel}
            style={{
              marginRight: "10px",
              padding: "10px 20px",
              borderRadius: "5px",
              border: "1px solid #ccc",
            }}
            disabled={isConverting}
          >
            閉じる
          </button>
          <button
            onClick={handleSave}
            style={{
              padding: "10px 20px",
              borderRadius: "5px",
              border: "none",
              color: "#fff",
              backgroundColor: "#007bff",
            }}
            disabled={isConverting}
          >
            保存
          </button>
        </div>
      </div>
    </div>
  );

  return ReactDOM.createPortal(
    modalContent,
    document.getElementById("modal-root")
  );
};

export default SettingsModal;